export class NotEnoughCreditsError extends Error {
  currentBalance: number;
  price: number;

  constructor(currentBalance: number, price: number) {
    super(
      `Not enough credits to perform an operation. Current balance: ${currentBalance}. Price: ${price}`,
    );
    this.name = "NotEnoughCreditsError";
    this.currentBalance = currentBalance;
    this.price = price;
  }
}
